<template>
  <div class="q-pa-md">
    <div class="row q-mb-sm">
      <q-select
        class="q-pa-xs col-6"
        label="Session"
        v-model.trim="sessionsDropDown"
        use-input
        hide-selected
        fill-input
        input-debounce="0"
        :options="sessionNamesOptions"
        @filter="sessionNamesFilter"
        @update:model-value="callFetchSessionComplexes(sessionsDropDown)"
      >
      </q-select>
      <q-space />
      <q-select
        v-if="sessionsDropDown"
        class="q-pa-xs col-6"
        label="Complexes"
        v-model="selectedComplexes"
        :options="sessionComplexNames"
        multiple
        use-chips
        @update:model-value="onRequest"
      >
        <template v-slot:selected-item="scope">
          <q-chip
            class="q-ma-xs"
            removable
            dense
            @remove="scope.removeAtIndex(scope.index)"
            @update:model-value="allSessionsSelected = false"
          >
            {{ scope.opt }}
          </q-chip>
        </template>
        <template v-slot:option="{ itemProps, opt, selected, toggleOption }">
          <q-item v-bind="itemProps">
            <q-item-section>
              <q-item-label v-html="opt" />
            </q-item-section>
            <q-item-section side>
              <q-toggle
                :model-value="selected"
                @update:model-value="toggleOption(opt)"
              />
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>

    <q-table
      title="Placements"
      :rows="placements"
      :columns="columns"
      row-key="name"
      v-model:pagination="pagination"
      :rows-per-page-options="[5, 10, 25, 50]"
      @request="onRequest"
      hide-header
      align="left"
      separator="none"
      dense
      no-data-label='No placements found with given criteria.'
    >
      <template v-slot:top>
        <div class="text-h6 q-mr-lg">
          Placements
        </div>
        <q-space />
        <q-select
          v-if="sessionsDropDown"
          class="q-pa-xs col-3"
          label="Filters"
          v-model="placementOptionsDropDown"
          :options="placementFiltersOptions"
          multiple
          use-chips
          @update:model-value="onRequest"
          dense
        >
          <template v-slot:selected-item="scope">
            <q-chip
              class="q-ma-xs"
              removable
              dense
              @remove="scope.removeAtIndex(scope.index)"
              @update:model-value="allSessionsSelected = false"
            >
              {{ scope.opt }}
            </q-chip>
          </template>
          <template v-slot:option="{ itemProps, opt, selected, toggleOption }">
            <q-item v-bind="itemProps">
              <q-item-section>
                <q-item-label v-html="opt" />
              </q-item-section>
              <q-item-section side>
                <q-toggle
                  :model-value="selected"
                  @update:model-value="toggleOption(opt)"
                />
              </q-item-section>
            </q-item>
          </template>
          <q-tooltip>
            Intersection of Each Filter
          </q-tooltip>
        </q-select>
        <q-input
          class="q-pa-md col-2"
          dense
          v-model.trim="filterModel"
          placeholder="Search"
          @keydown.enter="onRequest"
          :disable="sessionsDropDown ? false : ''"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
        <q-toggle
          v-model=isShowAllRas
          @update:model-value="expandAllRaToggles(isShowAllRas)"
          class="q-mr-sm"
          val="Expand"
          label="Expand"
        />
        <q-toggle
          v-model="isShowingUsername"
          class="q-mr-sm"
          val="Email"
          label="Email"
        />
        <q-toggle
          v-model="isShowingColleagueId"
          class="q-mr-sm"
          val="Colleague ID"
          label="Colleague ID"
        />
<!-- eslint-disable max-len -->
        <q-btn
          flat
          round
          label="Unit Color Legend"
          color="primary"
          icon="info"
          class="q-mr-sm"
        >
          <q-tooltip>
            <div class="text-body2 q-pa-sm">
              <div><b>Color Legend:</b></div>
              <div style="display: flex; align-items: center; margin: 2px 0;">
                <div style="width: 20px; height: 15px; background-color: #FFAB57; margin-right: 5px;"></div>
                <span>RA</span>
              </div>
              <div style="display: flex; align-items: center; margin: 2px 0;">
                <div style="width: 20px; height: 15px; background-color: grey; margin-right: 5px;"></div>
                <span>DSS</span>
              </div>
              <div style="display: flex; align-items: center; margin: 2px 0;">
                <div style="width: 20px; height: 15px; background-color: pink; margin-right: 5px;"></div>
                <span>Emergency/Facilities/RA/Sponsorship/Pending</span>
              </div>
              <div style="display: flex; align-items: center; margin: 2px 0;">
                <div style="width: 20px; height: 15px; background-color: #b9cfe4; margin-right: 5px;"></div>
                <span>Buyout</span>
              </div>
              <div style="display: flex; align-items: center; margin: 2px 0;">
                <div style="width: 20px; height: 15px; background-color: #ffef9e; margin-right: 5px;"></div>
                <span>Unassigned</span>
              </div>
              <div style="display: flex; align-items: center; margin: 2px 0;">
                <div style="width: 20px; height: 15px; background-color: #ffffff; margin-right: 5px; border: 1px solid #ddd;"></div>
                <span>Placed</span>
              </div>
              <div style="display: flex; align-items: center; margin: 2px 0;">
                <div style="width: 20px; height: 15px; background-color: #b5d694; margin-right: 5px;"></div>
                <span>Tentative</span>
              </div>
              <div style="display: flex; align-items: center; margin: 2px 0;">
                <div style="width: 20px; height: 15px; background-color: #A1856A; margin-right: 5px;"></div>
                <span>Blocked</span>
              </div>
              <br>
              <div><b>Note:</b> Opacity of 70% indicates placement is locked</div>
            </div>
          </q-tooltip>
        </q-btn>
        <q-btn
          v-if="sessionDetails.sessionType === 'Academic'
          || sessionDetails.sessionType === 'EAP'
          || sessionDetails.sessionType === 'Summer'"
          class="q-mr-xs"
          color="primary"
          label="Import Previous Applications"
          no-caps
          @click="confirmImportPreviousApplications = true"
        />
        <q-btn
          v-if="sessionDetails.sessionType === 'Academic'
          || sessionDetails.sessionType === 'EAP'
          || sessionDetails.sessionType === 'Summer'"
          class="q-mr-xs"
          color="primary"
          label="Import Previous Session"
          no-caps
          @click="confirmImportPreviousSession = true"
        />
        <q-btn
          v-if="sessionDetails.sessionType === 'Academic'
          || sessionDetails.sessionType === 'EAP'
          || sessionDetails.sessionType === 'Summer'
          || sessionDetails.sessionType === 'OIP'"
          class="q-mr-xs"
          color="primary"
          label="Run Algo"
          no-caps
          @click="confirmRunAlgo = true"
        />
        <q-btn
          v-if="false && // remove false && if activating
          sessionDetails.sessionType === 'Academic'
          || sessionDetails.sessionType === 'EAP'
          || sessionDetails.sessionType === 'Summer'
          || sessionDetails.sessionType === 'OIP'"
          class="q-mr-xs"
          color="primary"
          label="Confirm Placements"
          no-caps
          @click="confirmPlaceAll = true"
        />
        <!-- <q-btn
          class="q-mr-xs"
          color="primary"
          icon-right="archive"
        /> -->
        <!-- </div> -->
        <!-- </div> -->
      </template>
      <template v-slot:body="props">
        <q-tr>
          <q-td
            v-for="
              col
              in
              props.cols"
            :key="col.name"
            :props="props"
          >
            <q-toggle
              v-model="props.row.raToggle"
              checked-icon="add"
              unchecked-icon="remove"
              color="positive"
              :label="props.row.complexName"
              size="xs"
            />
          </q-td>
        </q-tr>
        <q-tr
          v-if="props.row.raToggle"
          :props="props"
        >
          <RaSection
            :complexId="props.row.complexId"
            :raId="props.row.raId"
            :sessionId="currentPlacementSessionId"
            :searchFilter="filterModel"
          />
        </q-tr>
      </template>
    </q-table>
    <q-dialog
      v-model="confirmPlaceAll"
      persistent
    >
      <q-card>
        <q-card-section class="row items-center">
          <q-avatar
            icon="info"
            size="md"
            color="primary"
            text-color="white"
          />
          <span class="q-ml-sm">
            All unplaced and unlocked students will be officially placed.
            <br />
            Emails will be sent to student with placement information as
            <br />
            well as emails to relevant departments. Confirm to proceed.
          </span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            flat
            label="Cancel"
            v-close-popup
          />
          <q-btn
            flat
            color="primary"
            label="Confirm"
            @click="runPlaceAll(currentPlacementSessionId)"
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog
      ref="importPreviousSessionModal"
      v-model="confirmImportPreviousSession"
    >
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar
        icon="info"
        size="md"
        color="primary"
        text-color="white"
        />
        <span class="q-ml-sm">
          Warning: This can only be run if all placement statuses in current session are not placed.
          This will remove all existing current tentative placements and append the previous session
          placements to the current session and Import previous session applications.
        </span>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn
          flat
          label="Cancel"
          v-close-popup
        />
        <q-btn
          flat
          color="primary"
          label="Confirm"
          @click="onRunImportPreviousSession(currentPlacementSessionId)"
        />
      </q-card-actions>
    </q-card>
    </q-dialog>
    <q-dialog
      ref="importPreviousApplicationsModal"
      v-model="confirmImportPreviousApplications"
    >
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar
        icon="info"
        size="md"
        color="primary"
        text-color="white"
        />
        <span class="q-ml-sm">
          Warning: This will import previous session applications.
          Previous session applications will be added to the current session.
          Only Applications with a status of 'Placed' will be applied and
          any duplicate applications will be ignored.
        </span>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn
          flat
          label="Cancel"
          v-close-popup
        />
        <q-btn
          flat
          color="primary"
          label="Confirm"
          @click="onRunImportPreviousApplications(currentPlacementSessionId)"
        />
      </q-card-actions>
    </q-card>
    </q-dialog>
    <q-dialog
      ref="algorithmOptionsModal"
      v-model="confirmRunAlgo"
    >
      <!-- TODO change back to currentPlacementSessionId or 26 -->
      <AlgorithmOptions
        :session-id="currentPlacementSessionId"
        @confirm="runAlgoConfirm"
      />
      <!-- <q-card>
        <q-card-section class="row items-center">
          <q-avatar
            icon="info"
            size="md"
            color="primary"
            text-color="white"
          />
          <span class="q-ml-sm">
            All unplaced and unlocked students will be part of the placement algo.
            <br />
            Manually assigned students, unless locked or placed, will be 'reshuffled'.
          </span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            flat
            label="Cancel"
            v-close-popup
          />
          <q-btn
            flat
            color="primary"
            label="Confirm"
            @click="runAlgo(currentPlacementSessionId); expandAllRaToggles(false)"
            v-close-popup
          />
        </q-card-actions>
      </q-card> -->
    </q-dialog>
  </div>
</template>

<script>
import { onUnmounted, ref } from 'vue';
import { useQuasar } from 'quasar';
import useSession from '../../hooks/session';
import usePlacement from '../../hooks/placement';
import useSessionComplex from '../../hooks/sessionComplex';
import useUser from '../../hooks/user';
import useUiUtilities from '../../utilities/uiUtilities';

import RaSection from './RaSection.vue';
import AlgorithmOptions from './AlgorithmOptions.vue';

const columns = [
  {
    name: 'Complex Name', align: 'left', label: 'Complex Name', field: 'complexName',
  },
];
const sessionsDropDown = ref([]);

export default {
  async setup() {
    const $q = useQuasar();
    const {
      fetchSession,
      fetchSessionNameIds,
      resetSession,
      sessionDetails,
      sessionNameIds,
    } = useSession();
    const {
      fetchSessionComplexNames,
      sessionComplexes,
      sessionComplexNames,
    } = useSessionComplex();
    const {
      currentPlacementSessionId,
      fetchPlacementsBySession,
      filterModel,
      getUnPlacedUsers,
      isShowAllRas,
      isShowingColleagueId,
      isShowingUsername,
      pagination,
      placementOptionsDropDown,
      placements,
      runAlgo,
      runImportPreviousSession,
      runImportPreviousApplications,
      runPlaceAll,
      selectedComplexes,
    } = usePlacement();
    const { raNameList } = useUser();
    const { notifyResult } = useUiUtilities();

    const algorithmOptionsModal = ref(null);
    const importPreviousSessionModal = ref(null);
    const importPreviousApplicationsModal = ref(null);

    raNameList.value = [];

    onUnmounted(() => {
      selectedComplexes.value = [];
      placementOptionsDropDown.value = [];
      sessionsDropDown.value = [];
      placements.value = [];
    });

    resetSession();
    await fetchSessionNameIds(false, true);
    const sessionNames = Array.from(sessionNameIds.value, (x) => x.sessionName);
    const sessionNamesOptions = ref(sessionNames);

    const onRequest = async (props) => {
      $q.loading.show();
      const page = props?.pagination?.page ?? pagination.value.page;
      const rowsPerPage = props?.pagination?.rowsPerPage ?? pagination.value.rowsPerPage;
      const sortBy = props?.pagination?.sortBy ?? pagination.value.sortBy;
      const descending = props?.pagination?.descending ?? pagination.value.descending;

      await fetchPlacementsBySession(
        page, rowsPerPage, descending, sortBy,
        filterModel, selectedComplexes,
      );
      pagination.value.page = page;
      pagination.value.rowsPerPage = rowsPerPage;
      pagination.value.sortBy = sortBy;
      pagination.value.descending = descending;
      isShowAllRas.value = false;
    };

    const expandAllRaToggles = (isExpanded) => {
      for (let i = 0; i < placements.value.length; i += 1) {
        placements.value[i].raToggle = isExpanded;
      }
      isShowAllRas.value = isExpanded;
    };

    const callFetchSessionComplexes = async (currentSessionName) => {
      $q.loading.show();
      currentPlacementSessionId.value = sessionNameIds.value.filter(
        (x) => x.sessionName === currentSessionName,
      )[0].sessionId;
      await fetchSession(currentPlacementSessionId.value);
      await fetchSessionComplexNames(currentPlacementSessionId.value);
      await getUnPlacedUsers(currentPlacementSessionId.value);
      selectedComplexes.value = sessionComplexNames.value;
      placementOptionsDropDown.value = [];
      placements.value = [];
      await onRequest();
      expandAllRaToggles(true);
      $q.loading.hide();
    };

    const sessionNamesFilter = (val, update) => {
      update(() => {
        const needle = val.toLowerCase();
        sessionNamesOptions.value = sessionNames.filter(
          (v) => v.toLowerCase().indexOf(needle) > -1,
        );
      });
    };

    const runAlgoConfirm = () => {
      expandAllRaToggles(false);
      algorithmOptionsModal.value.hide();
    };

    const onRunImportPreviousSession = async (localSessionId) => {
      $q.loading.show();
      const response = await runImportPreviousSession(localSessionId);
      if (response?.status) {
        notifyResult(response.status, response);
      }
      if (response?.status === 200 || response?.status === 201) {
        importPreviousSessionModal.value.hide();
        expandAllRaToggles(false);
      }
      $q.loading.hide();
    };

    const onRunImportPreviousApplications = async (localSessionId) => {
      $q.loading.show();
      const response = await runImportPreviousApplications(localSessionId);
      if (response?.status) {
        notifyResult(response.status, response);
      }
      if (response?.status === 200 || response?.status === 201) {
        importPreviousApplicationsModal.value.hide();
        expandAllRaToggles(false);
      }
      $q.loading.hide();
    };

    return {
      algorithmOptionsModal,
      callFetchSessionComplexes,
      columns,
      confirmPlaceAll: ref(false),
      confirmRunAlgo: ref(false),
      confirmImportPreviousSession: ref(false),
      confirmImportPreviousApplications: ref(false),
      currentPlacementSessionId,
      expandAllRaToggles,
      filterModel,
      filterCheckedUnits: ref(false),
      importPreviousSessionModal,
      importPreviousApplicationsModal,
      isShowAllRas,
      isShowingUsername,
      isShowingColleagueId,
      onRequest,
      placementOptionsDropDown,
      placementFiltersOptions: [
        'Placed', 'Tentative', 'Unassigned',
        'Locked', 'Blocked',
        // 'First Preference Granted', 'Second Preference Granted',
        'DSS', 'Buyout', 'EmergencyUse', 'FacilitiesIssue', 'PendingOnboardingOffboarding', 'RA', 'Sponsorship', 'ESA',
        'Ungranted Apartment Preference', 'Ungranted Buyout', 'Ungranted Roommates', 'Mismatched Genders', 'OccupiedConcurrentSession'],
      pagination,
      placements,
      onRunImportPreviousSession,
      onRunImportPreviousApplications,
      runAlgo,
      runPlaceAll,
      selectedComplexes,
      sessionComplexes,
      sessionComplexNames,
      sessionDetails,
      sessionsDropDown,
      sessionNames,
      sessionNamesFilter,
      sessionNamesOptions,
      showDelete: ref(false),
      showStudentId: ref(false),
      runAlgoConfirm,
    };
  },
  components: {
    RaSection,
    AlgorithmOptions,
  },
};
</script>

<style lang="sass">
.grid-style-transition
  transition: transform .28s, background-color .28s
</style>
